import { render } from "./UnitCreateComponent.vue?vue&type=template&id=282a7863"
import script from "./UnitCreateComponent.vue?vue&type=script&lang=js"
export * from "./UnitCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Unit/UnitCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "282a7863"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('282a7863', __exports__)) {
    api.reload('282a7863', __exports__)
  }
  
  module.hot.accept("./UnitCreateComponent.vue?vue&type=template&id=282a7863", () => {
    api.rerender('282a7863', render)
  })

}


export default __exports__